export default {
  language: 'English',
  businessSectors: {
    title: 'Select up to 3 Business Sectors',
    selected: 'Selected',
    maxSelectionAlert: 'You can select up to 3 business sectors',
  },
  characteristics: {
    title: 'Select up to 3 Characteristics',
    selected: 'Selected',
    maxSelectionAlert: 'You can select up to 3 characteristics',
  },
  errors: {
    loadOptions: 'Failed to load options. Please try again later.',
    minSelection: 'Please select at least one option from each category.',
    generateFailed: 'Failed to generate startup. Please try again.',
  },
  loading: {
    generating: 'Generating your startup...',
  },
  buttons: {
    generate: 'Generate Startup',
    testGA: 'Test Google Analytics',
    checkEvents: 'Check Events',
  },
  debug: {
    mode: 'Debug Mode',
  },
  validation: {
    maxBusinessSectors: 'Maximum 3 business sectors selections allowed',
    maxCharacteristics: 'Maximum 3 characteristics selections allowed',
    invalidBusinessSectors: 'Invalid business sectors selections',
    invalidCharacteristics: 'Invalid characteristics selections',
  }
}; 